import api from '../common/api';

const basePath = '/mediaSources';

export default {
  getList(params = {}) {
    return api.get(basePath, { params });
  },
  create(mediaSource) {
    return api.post(basePath, mediaSource);
  },
  get(mediaSourceId, params = {}) {
    return api.get(`${basePath}/${mediaSourceId}`, { params });
  },
  update(mediaSourceId, mediaSource) {
    return api.put(`${basePath}/${mediaSourceId}`, mediaSource);
  }
};



// WEBPACK FOOTER //
// ./src/services/mediaSourceService.js